import './ccf-work-history-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfWorkHistoryIconProps extends SvgIconProps {
  bgColor?: string;
}
/**
 * component used to display work history icon
 * @param props - CcfWorkHistoryIconProps
 * @example - <CcfWorkHistoryIcon />
 * @returns SVG of work history icon
 */
export function CcfWorkHistoryIcon(props: CcfWorkHistoryIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="Work_History"
        data-name="Work History"
        clipPath="url(#clip-Work_History)"
      >
        <rect
          width="20"
          height="20"
          fill={props.bgColor ? props.bgColor : '#fff'}
        />
        <g
          id="Group_118157"
          data-name="Group 118157"
          transform="translate(-1 24019)"
        >
          <rect
            id="Rectangle_80238"
            data-name="Rectangle 80238"
            width="44"
            height="44"
            rx="2"
            transform="translate(0 -24020)"
            fill="#f2f2f2"
            opacity="0"
          />
          <g
            id="Group_118158"
            data-name="Group 118158"
            transform="translate(1 -24019)"
          >
            <g
              id="Rectangle_80239"
              data-name="Rectangle 80239"
              fill={props.bgColor ? props.bgColor : '#fff'}
              stroke="#000"
              strokeWidth="1"
              opacity="0"
            >
              <rect width="20" height="20" stroke="none" />
              <rect x="0.5" y="0.5" width="19" height="19" fill="none" />
            </g>
            <g id="history_data" transform="translate(-0.805 -1.185)">
              <path
                id="Path_24906"
                data-name="Path 24906"
                d="M11.541,1.92a8.942,8.942,0,0,0-5.58,1.9A9.287,9.287,0,0,0,2.908,8.026l-.421-.737a1.848,1.848,0,0,0-.526-.421H1.749a.633.633,0,0,0-.421.105A.8.8,0,0,0,.907,8.132l1.474,2.632a.822.822,0,0,0,.421.421.7.7,0,0,0,.632-.105L6.066,9.606c.316,0,.421-.211.526-.421a1.792,1.792,0,0,0-.105-.737,1.051,1.051,0,0,0-.526-.421,1.335,1.335,0,0,0-.632.105l-.842.421A7.417,7.417,0,0,1,11.541,3.71a7.475,7.475,0,0,1,0,14.95,7.077,7.077,0,0,1-5.264-2.211.958.958,0,0,0-1.263,0,.961.961,0,0,0,0,1.263,9.168,9.168,0,0,0,6.527,2.737,9.265,9.265,0,0,0,0-18.53Z"
                transform="translate(0 0)"
              />
              <path
                id="Path_24907"
                data-name="Path 24907"
                d="M15.882,9.28a.906.906,0,0,0-.842.842v4.632a.906.906,0,0,0,.842.842h3.9a.842.842,0,0,0,0-1.685H16.725v-3.79a.906.906,0,0,0-.842-.842Z"
                transform="translate(-4.868 -2.517)"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfWorkHistoryIcon;
